document.addEventListener('DOMContentLoaded',function(){
  var cancelBtn = document.querySelector(".cancelBtn");
  var img1 = document.querySelector(".img1");
  var img2 = document.querySelector(".img2");
  var astmLow = document.querySelector("#astm-low");
  var lowBtn = document.querySelector("#lowBtn");

  lowBtn.addEventListener("click",function(){

    astmLow.style.display = "block";
  });
    cancelBtn.addEventListener("click",function(e){
    astmLow.style.display = "none";
  })  
 })
